import React from 'react'
import Fields from 'components/common/Fields'
import getSelectedPostedBy from 'components/common/getSelectedPostedBy'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'

import { required, fieldHasErr, composeValidators } from 'utils/validations'

const showGenderOptions = value =>
  ['Self', 'Friend', 'Relative'].includes(value)

const showGenderError = (genderErr, postbyValue) =>
  genderErr && showGenderOptions(postbyValue)

const genderOptionsMap = {
  Son: 'Male',
  Daughter: 'Female',
  Brother: 'Male',
  Sister: 'Female',
  Self: '',
  Relative: '',
  Friend: '',
}

const Gender = ({ postedby }) => {
  const selectedPostedBy = getSelectedPostedBy(postedby.input.value)
  return (
    <>
      <Fields names={['gender']}>
        {({ gender }) => {
          return (
            <div
              className={`${formStyles.genderEleWrap} ${
                showGenderError(fieldHasErr(gender), selectedPostedBy)
                  ? formStyles.fullInputError
                  : ''
              }`}
              style={{
                display: showGenderOptions(selectedPostedBy) ? 'block' : 'none',
              }}
            >
              <div
                className={`form-check form-check-inline ${
                  formStyles.genderLabel
                }`}
              >
                <label
                  className={`form-check-label ${formStyles.layerRadioLable}`}
                  htmlFor="gender_label"
                >
                  {selectedPostedBy === 'Self' ? 'I am a' : '... who is a'}
                </label>
              </div>
              <Field
                type="radio"
                name="gender"
                value="Male"
                validate={composeValidators(required('gender'))}
              >
                {({ input, meta }) => (
                  <div className="form-check form-check-inline">
                    <input
                      data-testid="gender_male"
                      id="gender_male"
                      className="form-check-input"
                      type="radio"
                      {...input}
                    />

                    <label
                      className={`form-check-label ${
                        formStyles.layerRadioLable
                      }`}
                      htmlFor="gender_male"
                    >
                      Male
                    </label>
                  </div>
                )}
              </Field>
              <Field
                type="radio"
                name="gender"
                value="Female"
                validate={composeValidators(required('gender'))}
              >
                {({ input, meta }) => (
                  <div className="form-check form-check-inline">
                    <input
                      data-testid="gender_female"
                      id="gender_female"
                      className="form-check-input"
                      type="radio"
                      {...input}
                    />

                    <label
                      className={`form-check-label ${
                        formStyles.layerRadioLable
                      }`}
                      htmlFor="gender_female"
                    >
                      Female
                    </label>
                  </div>
                )}
              </Field>
            </div>
          )
        }}
      </Fields>
      <Fields names={['gender']}>
        {({ gender }) => {
          return (
            <OnChange name="postedby">
              {(value, previous) => {
                if (value !== previous) {
                  let selectedPostedBy = getSelectedPostedBy(value)
                  gender.input.onChange(genderOptionsMap[selectedPostedBy])
                }
              }}
            </OnChange>
          )
        }}
      </Fields>
      <Fields names={['gender']}>
        {({ gender }) => {
          return showGenderError(fieldHasErr(gender), selectedPostedBy) ? (
            <p
              data-testid="gender_error"
              className={`${formStyles.error} col-md-12`}
            >
              {gender.meta.error}
            </p>
          ) : null
        }}
      </Fields>
    </>
  )
}

export default Gender
